import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import { SignIn, Buildings, Warning } from "@phosphor-icons/react";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (e) {
      setError(e.response?.data?.detail || "Errore di accesso");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      {/* Left panel */}
      <div className="hidden lg:flex lg:w-1/2 bg-slate-900 text-white flex-col justify-between p-12 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: "linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)",
          backgroundSize: "40px 40px"
        }} />
        <div className="relative">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white text-slate-900 rounded-md flex items-center justify-center">
              <Buildings size={22} weight="duotone" />
            </div>
            <div>
              <div className="font-bold text-lg" style={{ fontFamily: "Chivo" }}>FCF MANAGER</div>
              <div className="text-xs text-slate-400 tracking-widest uppercase">Bandi & Rendicontazione</div>
            </div>
          </div>
        </div>
        <div className="relative">
          <div className="text-xs text-slate-400 uppercase tracking-[0.22em] mb-4">Piattaforma Professionale</div>
          <h1 className="text-4xl font-bold mb-4" style={{ fontFamily: "Chivo", letterSpacing: "-0.02em" }}>
            Rendicontazione bandi<br />pubblici, semplificata.
          </h1>
          <p className="text-slate-300 text-sm max-w-md leading-relaxed">
            Contratti di Filiera, PNRR, MASAF, ISMEA, GSE, PSR. Centralizza documenti, fatture, bonifici e controlli
            in un'unica piattaforma con AI e OCR integrati.
          </p>
        </div>
        <div className="relative flex items-center gap-4 text-xs text-slate-400">
          <span>© 2026 FCF Manager</span>
          <span>·</span>
          <span>v1.0</span>
        </div>
      </div>

      {/* Right form */}
      <div className="flex-1 flex items-center justify-center p-8 bg-white">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="mb-8">
            <div className="eyebrow mb-3">Accesso Consulenti</div>
            <h2 className="text-3xl font-bold text-slate-900" style={{ fontFamily: "Chivo" }}>Bentornato.</h2>
            <p className="text-slate-500 mt-2 text-sm">Accedi al tuo cruscotto di rendicontazione.</p>
          </div>

          {error && (
            <div className="mb-4 flex items-start gap-2 p-3 bg-red-50 border border-red-200 rounded-md text-sm text-red-700" data-testid="login-error">
              <Warning size={18} weight="fill" />
              <span>{error}</span>
            </div>
          )}

          <label className="block mb-4">
            <span className="eyebrow block mb-2">Email</span>
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full h-11 rounded-md border border-slate-300 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-transparent"
              data-testid="login-email"
            />
          </label>
          <label className="block mb-6">
            <span className="eyebrow block mb-2">Password</span>
            <input
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full h-11 rounded-md border border-slate-300 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-transparent"
              data-testid="login-password"
            />
          </label>
          <button
            type="submit" disabled={loading}
            className="w-full h-11 rounded-md bg-slate-900 text-white font-medium text-sm hover:bg-slate-800 transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
            data-testid="login-submit"
          >
            <SignIn size={18} weight="bold" />
            {loading ? "Accesso..." : "Accedi"}
          </button>

        </form>
      </div>
    </div>
  );
}
